import { render, staticRenderFns } from "./FatalError.vue?vue&type=template&id=c4ac5180&"
import script from "./FatalError.vue?vue&type=script&lang=js&"
export * from "./FatalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports